var echarts = require("../echarts");

require("./marker/MarkAreaModel");

require("./marker/MarkAreaView");

echarts.registerPreprocessor(function (opt) {
  // Make sure markArea component is enabled
  opt.markArea = opt.markArea || {};
});


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/markArea.js
// module id = 912
// module chunks = 0